<template>
  <div class="page">
    <div class="page-header">
      <Back @click="$router.back()" />
      <span> Ambil Toga & Deposit </span>
    </div>

    <div class="form" v-show="siswa.id">
      <table>
        <tr>
          <td>Nama</td>
          <td>:</td>
          <td>{{ siswa.nama_lengkap }}</td>
        </tr>
        <tr>
          <td>No Daftar</td>
          <td>:</td>
          <td>{{ siswa.no_daftar }}</td>
        </tr>
        <tr>
          <td>Angkatan</td>
          <td>:</td>
          <td>{{ siswa.angkatan_2 }}</td>
        </tr>
        <tr>
          <td>Kampus</td>
          <td>:</td>
          <td>{{ siswa.kampus }}</td>
        </tr>
        <tr>
          <td>Jurusan</td>
          <td>:</td>
          <td>{{ siswa.jurusan }}</td>
        </tr>
        <tr>
          <td>Ambil Deposit</td>
          <td>:</td>
          <td>{{ !wisuda.ambil_deposit ? "Belum" : "Sudah" }}</td>
        </tr>
        <tr>
          <td>Ambil Toga</td>
          <td>:</td>
          <td>{{ !wisuda.ambil_toga ? "Belum" : "Sudah" }}</td>
        </tr>
      </table>

      <div class="token">
        <img id="token-toga" />
        <img id="token-deposit" />
      </div>

      <button @click="cetak">Cetak Struk</button>
    </div>

    <button @click="scan()" :disabled="loadingScan" class="btn-scan">
      {{ loadingScan ? "Mengambil data.." : "Scan QRCode Wisuda" }}
    </button>
  </div>
</template>

<script>
import * as api from "./../api";
import Back from "./../assets/Back.vue";

export default {
  name: "app",
  components: {
    Back,
  },
  data() {
    return {
      kodeBooking: "",
      loadingScan: false,
      siswa: {},
      wisuda: {},
    };
  },
  methods: {
    scan() {
      setTimeout(() => {
        cordova.plugins.barcodeScanner.scan(
          (result) => {
            this.kodeBooking = result.text;

            this.loadingScan = true;
            api
              .get(
                "/v1/wisuda/CheckinController/getSiswa?no_booking=" +
                  this.kodeBooking
              )
              .then((r) => {
                this.loadingScan = false;
                if (r.valid) {
                  this.siswa = r.data.siswa;
                  this.wisuda = r.data.pendaftar;

                  this.wisuda.token_deposit = r.data.token.deposit;
                  this.wisuda.token_toga = r.data.token.toga;

                  this.wisuda.qr_deposit = r.data.base64.deposit;
                  this.wisuda.qr_toga = r.data.base64.toga;

                  const imgDeposit = document.querySelector("#token-deposit");
                  imgDeposit.src = r.data.base64.deposit;

                  const imgToga = document.querySelector("#token-toga");
                  imgToga.src = r.data.base64.toga;
                } else {
                  alert(r.message);
                }
              })
              .catch((e) => {
                this.loadingScan = false;
                alert("Server error");
              });
          },
          (error) => {
            alert("Scanning failed: " + error);
          }
        );
      }, 150);
    },
    cetak() {
      // Update Token Toga & Deposit
      api
        .postJson("/v1/wisuda/CheckinController/updateToken", {
          id: this.wisuda.id,
          token_toga: this.wisuda.token_toga,
          token_deposit: this.wisuda.token_deposit,
        })
        .then((r) => {
          var esc = "\x1B";
          var printer_helper = {
            lebar_kertas: 32,

            init: esc + "@",
            font_bold: esc + "!" + "\x21\x01",
            font_double_size: esc + "!" + "\x38",
            font_small_size: esc + "!" + "\x01",
            font_normal: esc + "!" + "\x02",
            reset_font: esc + "!" + "\x00",

            garis: function (val) {
              var g = "";
              for (var i = 0; i < printer_helper.lebar_kertas; i++) {
                g += val;
              }
              return g;
            },
          };

          // Cetak
          var text = printer_helper.init;
          text += printer_helper.font_bold + "PENGAMBILAN DEPOSIT" + "\n\n";
          text += printer_helper.font_normal;
          text += "NAMA      : " + this.siswa.nama_lengkap.toUpperCase() + "\n";
          text += "NO DAFTAR : " + this.siswa.no_daftar + "\n";

          // Cetak
          var text2 = printer_helper.garis("-") + "\n\n" + printer_helper.init;
          text2 += printer_helper.font_bold + "PENGAMBILAN TOGA" + "\n\n";
          text2 += printer_helper.font_normal;
          text2 +=
            "NAMA      : " + this.siswa.nama_lengkap.toUpperCase() + "\n";
          text2 += "NO DAFTAR : " + this.siswa.no_daftar + "\n";

          // CETAK DEPOSIT
          BTPrinter.printText(
            (data) => {
              // CETAK QR DEPOSIT
              BTPrinter.printBase64(
                (data) => {
                  setTimeout(() => {
                    // CETAK TEXT TOGA
                    BTPrinter.printText(
                      (data) => {
                        // CETAK QR TOGA
                        BTPrinter.printBase64(
                          (data) => {
                            BTPrinter.printText(
                              (data) => {
                                this.kodeBooking = "";
                                this.siswa = {};
                                this.wisuda = {};
                              },
                              (err) => {},
                              "\n\n"
                            );
                          },
                          (err) => {},
                          this.wisuda.qr_toga,
                          "2"
                        );
                      },
                      (err) => {
                        alert("Gagal cetak");
                      },
                      text2
                    );
                  }, 2000);
                },
                (err) => {},
                this.wisuda.qr_deposit,
                "2"
              );
            },
            (err) => {
              alert("Gagal cetak");
            },
            text
          );
        })
        .catch((e) => {
          this.loadingScan = false;
          alert("Server error");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding-top: 60px;
  .form {
    margin-top: 20px;
    table {
      margin-bottom: 15px;
      tr {
        td {
          padding: 3px 0;
          font-size: 14px;
          &:nth-child(2) {
            padding: 0 5px 0 10px;
          }
          &:last-child {
            font-weight: 600;
          }
        }
      }
    }

    .token {
      display: grid;
      grid-template-columns: 1fr 1fr;
      border: 1px solid #999;
      border-radius: 8px;
      margin-bottom: 20px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }

  .btn-scan {
    position: fixed;
    bottom: 20px;
    left: 20px;
    width: calc(100% - 40px);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Pengambilan.vue